import React from "react"
import { Link } from 'gatsby'

const Header = () => {
  const url = typeof window !== 'undefined' ? window.location.href : '';
  return (
    <header className="header">
      <nav className="navbar navbar-expand-sm">
        <Link className="navbar-brand d-sm-none" to="/"><img src="../../bonsaiLogo.svg" alt="bonsai logo"/></Link>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto">
            <li className="nav-item">
              <Link
                to="/about"
                className={`nav-link ${url.includes('about') ? 'active' : ''}`}
              >
                about
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/successes"
                className={`nav-link ${url.includes('successes') ? 'active' : ''}`}
              >
                successes
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/blog"
                className={`nav-link ${url.includes('blog') ? 'active' : ''}`}
              >
                blog
              </Link>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  )
}

export default Header
